import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaLayerGroup, FaFlask, FaArrowDown, FaRocket } from 'react-icons/fa';
import './LaboratoryTrigger.css';

/**
 * Laboratory Trigger simple avec tailles harmonisées
 */
const LaboratoryTrigger = ({ onClick, className = '', ...props }) => {
  const { t } = useTranslation();
  
  return (
    <div 
      className={`laboratory-trigger-unified ${className}`}
      onClick={onClick}
      {...props}
    >
      {/* Effet de background subtil */}
      <div className="laboratory-trigger-bg-effect" />
      
      {/* Header du cartouche */}
      <div className="laboratory-trigger-header">
        <div className="laboratory-trigger-icon">
          <FaFlask />
        </div>
        <div className="laboratory-trigger-content">
          <h3 className="laboratory-trigger-title">
            {t('featureManager.actions.laboratoryLabel')}
          </h3>
          <p className="laboratory-trigger-description">
            {t('featureManager.actions.laboratoryTooltip')}
          </p>
        </div>
      </div>

      {/* Features présentées */}
      <div className="laboratory-trigger-features">
        <div className="laboratory-trigger-feature">
          <FaLayerGroup />
          <span>Sections</span>
        </div>
        <div className="laboratory-trigger-feature">
          <FaRocket />
          <span>Navigation</span>
        </div>
      </div>

      {/* Call to action avec icône */}
      <div className="laboratory-trigger-cta">
        <span className="cta-text" style={{
          display: 'flex',
          alignItems: 'center',
          fontWeight: 'bold'
        }}>
          <span className="cta-icon" style={{ marginRight: '8px', fontSize: '1.2em' }}>⚡🔬</span>
          {t('featureManager.actions.laboratoryCta')}
        </span>
        <FaArrowDown className="laboratory-trigger-arrow" style={{
          color: '#FFFFFF',
          filter: 'drop-shadow(0 0 4px rgba(255,255,255,0.6))'
        }} />
      </div>
    </div>
  );
};

export default LaboratoryTrigger;